import styled from 'styled-components';

import Button from 'web-components/Button';

export const Close = styled(Button).attrs({
  appearance: 'link',
})`
  color: #000000;
  font-size: 13px;
  font-weight: normal;
  text-shadow: none;
  opacity: 0.7;
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
  position: absolute;
  top: 20px;
  right: 30px;
  z-index: 9;

  &:hover {
    opacity: 0.9;
  }
`;

export const Upgrade = styled(Button).attrs({
  type: 'button',
  appearance: 'success',
})`
  font-size: 16px;
  display: block;
  padding: 8px 29px;
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;

  ${props => props.isDisabled && `
    opacity: 0.55;
  `}
`;
